import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-737c48f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "form-block"
}
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "mb-2" }

import { useValidateProps } from "@/composables/fields";
import { HakoInput, LabelControl } from "@hakosalo/hakolib";
import { computed, inject, PropType } from "vue";
import { getMunicipalityTranslation } from "@/helpers";
import Validation from "./form/Validation.vue";
import { AddressDto } from "@api/address-dto";
import { PostalCodeDto } from "@api/postal-code-dto";
import { MunicipalityDto } from "@api/municipality-dto";
import publicFormApi from "@/publicFormApi";
import { Field } from "@/types/interfaces/field";

export interface Address {
	streetAddress: string;
	municipalityId: number;
	postalCodeId: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressBlock',
  props: {
	label: String,
	infoidentifier: String,
	idPrefix: {
		type: String,
		required: true,
	},
	modelValue: {
		type: Object as PropType<AddressDto | null>,
		required: true,
	},
	parentPath: {
		type: String,
		default: "",
	},
	maxwidth: String,
	field: {
		type: Object as PropType<Field>,
		required: false,
	},
	isUpdateForm: {
		type: Boolean,
		required: false,
		default: false,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const validateProps = useValidateProps();
const orgUsingPublicDirectory = inject("orgUsingPublicDirectory", false);

const vModel = computed({
	get() {
		return props.modelValue;
	},
	set(newVal: AddressDto | null) {
		emit("update:modelValue", newVal);
	},
});

const getPropPath = (localPath: string) => {
	if (props.parentPath) {
		return props.parentPath + "." + localPath;
	}

	return localPath;
};

const onPostalcodeChange = async (e: PostalCodeDto | null) => {
	vModel.value!.postalCodeId = e?.id || null;
	if (vModel.value!.postalCodeId && vModel.value && e) {
		if (e.municipality) {
			vModel.value!.municipalityId = e.municipality.code;
			vModel.value!.municipality = e.municipality;
		}
	}
};

return (_ctx: any,_cache: any) => {
  const _component_HakoSingleSelect2 = _resolveComponent("HakoSingleSelect2")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(LabelControl), {
              for: __props.idPrefix + '_streetAddress',
              block: true,
              "col-size": 2,
              infoidentifier: __props.infoidentifier,
              required: 
						(__props.field &&
							(__props.isUpdateForm
								? __props.field?.isRequiredOnCompanyUpdateForm
								: __props.field?.isRequiredOnPublicForm)) ||
						false
					
            }, {
              label: _withCtx(() => [
                _renderSlot(_ctx.$slots, "label"),
                (!_ctx.$slots.label)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(__props.label || _ctx.$t("generic.streetAddress")) + " ", 1),
                      (__props.isUpdateForm && _unref(orgUsingPublicDirectory))
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: "show-public-icon",
                            style: _normalizeStyle(
									__props.field?.isDisplayedInPublicDirectory
										? 'background-color: #32b769'
										: 'background-color: gray'
								)
                          }, null, 4))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(Validation, {
                  fieldName: _ctx.$t('generic.streetAddress'),
                  propertyPaths: [getPropPath('streetAddress')]
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(_unref(HakoInput), {
                      id: __props.idPrefix + '_streetAddress',
                      noFloat: "",
                      modelValue: vModel.value!.streetAddress,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vModel.value!.streetAddress) = $event))
                    }, null, 8, ["id", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["fieldName", "propertyPaths"])
              ]),
              _: 3
            }, 8, ["for", "infoidentifier", "required"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(LabelControl), {
              for: __props.idPrefix + '_postalCode',
              block: true,
              "col-size": 2,
              required: 
						(__props.field &&
							(__props.isUpdateForm
								? __props.field?.isRequiredOnCompanyUpdateForm
								: __props.field?.isRequiredOnPublicForm)) ||
						false
					
            }, {
              label: _withCtx(() => [
                _renderSlot(_ctx.$slots, "label"),
                (!_ctx.$slots.label)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t("generic.postalCodeAndMunicipality")) + " ", 1),
                      (__props.isUpdateForm && _unref(orgUsingPublicDirectory))
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: "show-public-icon",
                            style: _normalizeStyle(
									__props.field?.isDisplayedInPublicDirectory
										? 'background-color: #32b769'
										: 'background-color: gray'
								)
                          }, null, 4))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "d-flex gap-2",
                  style: _normalizeStyle(__props.maxwidth ? 'max-width:' + __props.maxwidth : '')
                }, [
                  _createElementVNode("div", null, [
                    _createVNode(Validation, {
                      fieldName: _ctx.$t('generic.postalCode'),
                      propertyPaths: [getPropPath('postalCodeId')]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_HakoSingleSelect2, {
                          useWindowMenu: "",
                          modelValue: vModel.value!.postalCode,
                          "onUpdate:modelValue": [
                            _cache[1] || (_cache[1] = ($event: any) => ((vModel.value!.postalCode) = $event)),
                            _cache[2] || (_cache[2] = (e) => {
										onPostalcodeChange(e)
									})
                          ],
                          optionGenerator: (o) => ({
										text: o.postcode,
										value: o
									}),
                          optionLoader: 
										async (s, page) => {
											var r = await _unref(publicFormApi).call.form.get.postalCodes(s, page);
											return r.data || [];
										}
									,
                          optionComparer: (o) => o.id
                        }, null, 8, ["modelValue", "optionGenerator", "optionLoader", "optionComparer"])
                      ]),
                      _: 1
                    }, 8, ["fieldName", "propertyPaths"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(Validation, {
                      fieldName: _ctx.$t('generic.postalMunicipality'),
                      propertyPaths: [getPropPath('municipalityId')]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_HakoSingleSelect2, {
                          modelValue: vModel.value!.municipality,
                          "onUpdate:modelValue": [
                            _cache[3] || (_cache[3] = ($event: any) => ((vModel.value!.municipality) = $event)),
                            _cache[4] || (_cache[4] = (e) => {
										vModel.value!.municipalityId = (e?.code || null)
									})
                          ],
                          optionGenerator: (o) => ({
										text: _unref(getMunicipalityTranslation)(o) ?? '',
										value: o
									}),
                          optionLoader: 
										async (s, page) => {
											var r = await _unref(publicFormApi).call.form.get.municipalities(s, page);
											return r.data || [];
										}
									,
                          optionComparer: (o) => o.code
                        }, null, 8, ["modelValue", "optionGenerator", "optionLoader", "optionComparer"])
                      ]),
                      _: 1
                    }, 8, ["fieldName", "propertyPaths"])
                  ])
                ], 4)
              ]),
              _: 3
            }, 8, ["for", "required"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})